import React, { LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    required?: boolean;
    optional?: boolean;
}

const Label: React.FC<LabelProps> = ({
    children,
    required,
    optional,
    className = '',
    ...props
}) => (
    <label className={cn('input-label', className)} {...props}>
        {children}
        {required && <span className="ml-1 text-error">*</span>}
        {optional && <span className="ml-1 font-normal text-muted">(opcional)</span>}
    </label>
);

export default Label;
